<template>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="true" 
        :on-cancel="onCancel"
        :is-full-page="fullPage"
        :color="green"></loading>


  <loader object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>

        
        <!-- <label><input type="checkbox" v-model="fullPage">Full page?</label>
        <button @click.prevent="doAjax">fetch Data</button> -->
    </div>
</template>

<script>
import Vue from 'vue';
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
//import Vue from 'vue'
// import Loading from 'vue-loading-overlay';

// import 'vue-loading-overlay/dist/vue-loading.css';

import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
    	isLoading: false,
        fullPage: true
   }

  },
  created: function() { 
    
        this.doAjax()
  },

  // components: {
  //           Loading
  //       },
  methods: 
  {  
  	 doAjax() {
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                  this.isLoading = false
                },5000)
            },
            onCancel() {
              console.log('User cancelled the loader.')
            }
    

  }
}
</script>
